<template>
    <div class="cont">
        <div class="count">
            {{count}}%
        </div>
        <div class="progress-container">
        <div class="el" ref="el"></div>
        </div>
    </div>
</template>

<script>
    import {translate} from '../animation/ProgressLoadingAnimation'
    import anime from 'animejs'
    import {mapGetters} from 'vuex'

    export default {
        name: "ProgressLoading",
        computed: {
            ...mapGetters(['getResult']),
            progress() {
                return this.getResult.progress;
            }
        },
        methods: {
            progressStatusAnimDuration(value) {
                const startInterval = setInterval(() => {
                    if (this.count < +value) {
                        this.count += 1
                        this.animation.seek(this.animation.duration * (this.count / 100));
                    }
                }, 50)
                return startInterval;
            }
        },
        mounted() {
            this.animation = translate(this.$refs.el)
            anime({
                targets: this.$refs.test,
                backgroundColor: '#004DFF',
                easing: 'easeInOutQuad',
                duration: 3000

            })
        },
        watch: {
            progress(newValue, oldValue) {
                this.progressStatusAnimDuration(newValue)
            },
            count(newValue, oldValue) {
                if (newValue == this.progress) {
                    this.$emit('progress', {progress: newValue})

                }
            },

        },
        data() {
            return {
                animation: {},
                count: 0,
                loadingComplete: false
            }
        }
    }
</script>

<style scoped>
    .el {
        width: 10px;
        height: 10px;
        background-color: red;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        border-radius: 40px;
    }

    .test {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        display: flex;
        background-color: orange;
    }

    .cont {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        width: 90%;
        flex-direction: column;
    }
    .progress-container {
        border: solid 1px;
        width: 100%;
        border-radius: 40px;
    }
</style>
